export const createStopwatch = () => {
  const startTime = Date.now().valueOf()
  return () => Date.now().valueOf() - startTime
}
